import { useEffect } from 'react'

import useOfferList from 'hooks/Offers/useOfferList'
import { MINIMUM_OFFERS_TO_SHOW_CAROUSEL } from './loyaltySpendPointsConstants'

interface Props {
  filters: App.OfferListFilters
  value: string
  onAvailabilityChange: (value: string, isAvailable: boolean) => void
}

function LoyaltySpendPointsOfferFilterPrefetch(props: Props) {
  const { filters, value, onAvailabilityChange } = props
  const offerList = useOfferList(filters)

  // Streamed lists flip `fetching` false on the first batch, well before all results have
  // arrived (see offer.ts's FETCH_OFFER_LIST success reducer) — wait for streamEnded too so we
  // don't report a destination as unavailable before its later-arriving offers are counted.
  const isSettled = filters.isStream ? !!offerList.streamEnded : !offerList.fetching

  useEffect(() => {
    if (isSettled) {
      onAvailabilityChange(value, offerList.offerIds.length >= MINIMUM_OFFERS_TO_SHOW_CAROUSEL)
    }
  }, [isSettled, offerList.offerIds.length, onAvailabilityChange, value])

  return null
}

export default LoyaltySpendPointsOfferFilterPrefetch
